module.exports = __webpack_public_path__ + "img/back.72f5d021.png";